import PageHeader from "@/components/PageHeader";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const faqs = [
  {
    q: "Who can come?",
    a: "All high school students! Rising freshmen through rising seniors are welcome.",
  },
  {
    q: "Do I have to be a Christian?",
    a: "Not at all! Everyone is welcome. Whether you have followed Jesus for years or you are just curious about faith, we would love to have you.",
  },
  {
    q: "Is it free?",
    a: "Yes! Everything is completely free.",
  },
  {
    q: "What should I expect?",
    a: "Lots of community, games, worship, and a short message centered on Jesus.",
  },
  {
    q: "What should I wear?",
    a: "Casual. Wear whatever you are comfortable in.",
  },
  {
    q: "Can I bring a friend?",
    a: "Absolutely. Bring as many friends as you want.",
  },
  {
    q: "How often do you meet?",
    a: "Once a month.",
  },
  {
    q: "Where are gatherings held?",
    a: "Gatherings are hosted at different homes around Richmond. The address will be posted before each gathering.",
  },
  {
    q: "Do I have to go to a specific church?",
    a: "No. RVA Students is open to students from every church or no church at all.",
  },
  {
    q: "How is this different than youth group?",
    a: "We are not part of any church. We want students to meet each other from other churches so you can build your relationship with Jesus alongside a wider community — knowing you are never alone.",
  },
  {
    q: "How can I get involved?",
    a: "Come to a gathering, invite friends, volunteer, and check out the Get Involved page.",
  },
];

const FaqPage = () => {
  return (
    <>
      <PageHeader
        overline="Real Questions, Real Answers"
        title="Ask Us"
        accent="Anything."
        subtitle="We get it — showing up somewhere new comes with questions. Here are the ones we hear most."
        testId="faq-header"
      />

      <section className="relative pb-24 md:pb-32" data-testid="faq-section">
        <div className="glow-blue top-0 -left-40 opacity-40" />
        <div className="relative max-w-4xl mx-auto px-6 md:px-12">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-white/10 py-2"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left font-heading font-bold text-xl md:text-2xl uppercase tracking-tight hover:no-underline hover:text-forest-glow py-6 [&[data-state=open]]:text-forest-glow"
                  data-testid={`faq-trigger-${i}`}
                >
                  <span className="flex items-start gap-6">
                    <span className="text-sm text-white/30 font-heading pt-2 shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span>{f.q}</span>
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="text-base md:text-lg text-white/70 leading-relaxed pb-8 pl-14 pr-6"
                  data-testid={`faq-answer-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="mt-20 p-10 md:p-14 card-glass text-center" data-testid="faq-still-questions">
            <p className="overline mb-4">Still Have Questions?</p>
            <h3 className="font-heading font-black text-3xl md:text-4xl uppercase leading-tight tracking-tight mb-8">
              We'd love to hear from you.
            </h3>
            <Link to="/contact" className="btn-primary" data-testid="faq-contact-button">
              Reach Out <ArrowUpRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default FaqPage;
